import { useMemo } from "react";
import { StyleSheet } from "react-native";
import { useStack, SPACE, Notification } from "@lookiero/aurora";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { elevationColor, elevationOffset, elevationOpacityM, elevationRadius } = theme();

  return StyleSheet.create({
    container: {
      shadowColor: elevationColor,
      shadowOffset: elevationOffset,
      shadowOpacity: elevationOpacityM,
      shadowRadius: elevationRadius,
    },
  });
};

interface ShowMessageParams {
  readonly message: string;
  readonly settings?: Record<string, unknown>;
}

const TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};

const NOTIFICATION_DEFAULTS = {
  marginTop: SPACE.SPACE_4,
  marginHorizontal: SPACE.SPACE_4,
  timeoutClose: 10000,
};

const generateUid = () => new Date().getTime().toString();

const useToast = () => {
  const Stack = useStack();

  const notificationStyle = useMemo(() => style(), []);

  return {
    show: (props: Record<string, unknown>) => {
      Stack.show(generateUid(), Notification, props);
    },
    showError: ({ message, settings = {} }: ShowMessageParams) => {
      Stack.critical(generateUid(), Notification, {
        ...NOTIFICATION_DEFAULTS,
        style: notificationStyle.container,
        ...settings,
        text: message,
      });
    },
    showSuccess: ({ message, settings = {} }: ShowMessageParams) => {
      Stack.success(generateUid(), Notification, {
        ...NOTIFICATION_DEFAULTS,
        style: notificationStyle.container,
        ...settings,
        text: message,
      });
    },
    showWarning: ({ message, settings = {} }: ShowMessageParams) => {
      Stack.warning(generateUid(), Notification, {
        ...NOTIFICATION_DEFAULTS,
        style: notificationStyle.container,
        ...settings,
        text: message,
      });
    },
    hide: (id: string) => {
      Stack.hide(id);
    },
  };
};

export { useToast, TOAST_TYPES, generateUid };
